import {
    getAuth,
    EmailAuthProvider,
    reauthenticateWithCredential,
    updatePassword,
    updateEmail,
  } from "firebase/auth";
  
  /**
   * Updates the Firebase user's password after reauthentication.
   *
   * @param {Object} params
   * @param {string} params.oldPassword - The user's current password.
   * @param {string} params.newPassword - The new password to set.
   * @param {string} params.confirmPassword - Confirmation of the new password.
   * @returns {Promise<void>}
   */
  export async function updateUserPassword({ oldPassword, newPassword, confirmPassword }) {
    const auth = getAuth();
    const user = auth.currentUser;

    const updatedUser = JSON.parse(localStorage.getItem("userData") || "{}");
    const updatedUserEmail = updatedUser?.user?.email;
    console.log(updatedUserEmail, "updatedUserEmail");
  
    if (!user) {
      return {
        success: false,
        error: "No user is currently signed in.",
      };
    }
  
    if (newPassword !== confirmPassword) {
      return {
        success: false,
        error: "New password and confirmation do not match.",
      };
    }
  
    const credential = EmailAuthProvider.credential(updatedUserEmail||user.email, oldPassword);
  
    try {
      // Step 1: Reauthenticate the user
      await reauthenticateWithCredential(user, credential);
  
      // Step 2: Update the password
      await updatePassword(user, newPassword);
  
      console.log("Password updated successfully.===");
      return {
        success: true,
        message: "Password updated successfully.",
      };
    } catch (error) {
      console.error("Error updating password:", error.message);
      return {
        success: false,
        error: error.message,
      };
    }
  }
  

  export async function updateUserEmail(newEmail, user) {
    // const auth = getAuth(); 
    // const user = auth.currentUser;
  
    if (!user) {
      return {
        success: false,
        error: "No user is currently signed in.",
      };
    }
  
    try {
      await updateEmail(user, newEmail);
      console.log("Email updated successfully.");
      return {
        success: true,
        message: "Email updated successfully.",
      };
    } catch (error) {
      console.error("Error updating email:", error.message);
      return {
        success: false,
        error: error.message,
      };
    }
  }